var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avue-input-map',{ref:"map",attrs:{"params":_vm.params,"placeholder":_vm.placeholder},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})
}
var staticRenderFns = []

export { render, staticRenderFns }